import { inject, Injectable } from '@angular/core';
import { ApiGateway } from '@sb/shared/api';
import { map } from 'rxjs';

import type { FileUploadResult } from '../../models/contract-template.model';
import type { WireDetection } from '../models/detection-wire.model';
import { adaptDetection } from './detection-adapter.helper';

/** Failures are read by the builder and shown inline, so the global error toast stays off. */
const QUIET = { headers: { ignoreMetaMessage: true } };

@Injectable({ providedIn: 'root' })
export class AiTemplateBuilderApiService {
  #gateway = inject(ApiGateway);
  #templates = 'documents/templates';
  #endpoint = `${this.#templates}/detect_variables`;

  upload(file: File) {
    return this.#gateway.post<FileUploadResult>('attachments/upload', file, { ...QUIET });
  }

  /** Starts a run, or returns the one still pending for this resource. The file itself never goes through here. */
  detect(resourceId: string) {
    return this.#gateway.post<WireDetection>(this.#endpoint, { resourceId }, { ...QUIET }).pipe(map(adaptDetection));
  }

  /** The latest run for this resource. A 404 means no run is on record, 403 that access was lost. */
  status(resourceId: string) {
    return this.#gateway.get<WireDetection>(`${this.#endpoint}/${resourceId}`, { ...QUIET }).pipe(map(adaptDetection));
  }

  /** The backend contract for this download is not published yet, so the path is an assumption kept in this one place. */
  downloadWithoutHighlights(resourceId: string, fileName?: string) {
    return this.#gateway.download(`${this.#templates}/download_without_highlights/${resourceId}`, fileName, {
      ...QUIET,
    });
  }
}
